<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class=""
    >Cadastro Hiperdia</mat-card-title
    >
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <div [formGroup]="form" class="mt-8 mb-0">
    <div>
      <div class="flex justify-between gap-4 items-center">
        <mat-form-field class="input-tg w-3/12" appearance="outline">
          <mat-label>Nome Fantasia</mat-label>
          <input matInput formControlName="fantasy_name" />
        </mat-form-field>
        <mat-form-field class="input-tg w-3/12" appearance="outline">
          <mat-label>Razão Social</mat-label>
          <input matInput formControlName="corporate_name" />
        </mat-form-field>
        <mat-form-field class="input-tg w-3/12" appearance="outline">
          <mat-label>CNPJ</mat-label>
          <input matInput [mask]="'99.999.999/9999-99'" formControlName="cnpj" />
        </mat-form-field>
        <mat-form-field
          class="input-tg w-2/12"
          appearance="outline"
        >
          <mat-label>Telefone Fixo</mat-label>
          <input matInput formControlName="phone_number" [mask]="'(99) 99999-9999'" />
        </mat-form-field>
        <mat-form-field
          class="input-tg w-2/12"
          appearance="outline"
        >
          <mat-label>Telefone Whatsapp</mat-label>
          <input matInput formControlName="phone_number_whatsapp" [mask]="'(99) 99999-9999'" />
        </mat-form-field>
      </div>
      <div class="flex justify-start gap-4 items-center">
        <mat-form-field
          class="input-tg w-4/12"
          appearance="outline"
        >
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" />
        </mat-form-field>
        <mat-form-field class="input-tg w-4/12" appearance="outline">
          <mat-label>Senha</mat-label>
          <input matInput formControlName="password" />
        </mat-form-field>
        <mat-form-field class="input-tg w-4/12" appearance="outline">
          <mat-label>CEP</mat-label>
          <input matInput (input)="getAddressByPostalCode()"
                 (blur)="getAddressByPostalCode()" [mask]="'99999-999'" formControlName="postal_code" />
        </mat-form-field>

      </div>
    </div>
    <div class="mt-8 mb-0">
      <div>
        <div class="flex justify-between gap-4 items-center">
          <mat-form-field class="input-tg w-4/12" appearance="outline">
            <mat-label>Logradouro</mat-label>
            <input matInput formControlName="street" />
          </mat-form-field>
          <mat-form-field class="input-tg w-4/12" appearance="outline">
            <mat-label>Número</mat-label>
            <input matInput formControlName="number" />
          </mat-form-field>
          <mat-form-field class="input-tg w-4/12" appearance="outline">
            <mat-label>Bairro</mat-label>
            <input matInput formControlName="neighborhood" />
          </mat-form-field>
        </div>
        <div class="flex justify-start gap-4 items-center">
          <mat-form-field class="input-tg w-4/12" appearance="outline">
            <mat-label>Município</mat-label>
            <mat-select formControlName="municipality">
              @for (type of listMunicipios; track type) {
                <mat-option [value]="type.id">{{ type.nome }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="input-tg w-4/12" appearance="outline">
            <mat-label>Estado</mat-label>
            <input matInput formControlName="state" />
          </mat-form-field>
          <mat-slide-toggle
            class="input-tg w-3/12 px-2"
            formControlName="active"
          >Status:
            <strong>{{
                form.get('active')?.value ? 'Ativo' : 'Inativo'
              }}</strong></mat-slide-toggle
          >

        </div>
      </div>

      <div class="flex justify-end mt-3">
        <button
          mat-flat-button
          class="btn-tg w-1/5"
          [disabled]="!this.form.valid || loading"
          (click)="createLocation()"
        >
          @if (loading) {
            <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
          } @else {
            Cadastrar
          }
        </button>
      </div>
    </div>
  </div>
</mat-card>
